import { Controller } from "@hotwired/stimulus"

// Slide-over panel for adding/editing form-template fields. The "Add Field" /
// "Edit" links load the field form into the #field_form turbo-frame inside the
// drawer; this controller just slides the drawer in/out. Saving streams the row
// into the table and re-renders the panel (drawer stays open for rapid add).
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
  }

  open() {
    this.element.classList.add("field-drawer-open")
    document.addEventListener("keydown", this.onKeydown)
  }

  close() {
    this.element.classList.remove("field-drawer-open")
    document.removeEventListener("keydown", this.onKeydown)
    // Clear the frame so the next open re-fetches a fresh form (no stale errors
    // or a previously-edited field lingering).
    if (this.hasFrameTarget) this.frameTarget.replaceChildren()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }
}
